import React, { useEffect, useRef, useState } from "react"
import "./TaskDataTable.scss"
import {
  Button,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import TaskApi from "Api/TaskApi"
import { useNavigate } from "react-router-dom"

const TaskDataTable = () => {
  document.title = "Task"
  const navigate = useNavigate()
  const [page, setPage] = useState(1)
  const [taskDetails, setTaskDetails] = useState([])
  const [loading, setLoading] = useState(true)
  const [totalRecords, setTotalRecords] = useState(0)

  const limit = 10
  const totalPages = Math.ceil(totalRecords / limit)
  const accessToken = localStorage.getItem("accessToken")
  const userData = JSON.parse(localStorage.getItem("userData"))

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Task", link: "#" },
    { label: "Task List", link: "#" },
  ]

  const getAllTasks = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit,
        page,
      },
    }

    TaskApi.getAnalystTaskById(userData._id, config)
      .then(response => {
        if (response.data.status) {
          setLoading(false)
          setTaskDetails(response.data.tasks)
          setTotalRecords(response.data.totalRecords)
        }
      })
      .catch(error => {
      })
  }

  useEffect(() => {
    getAllTasks()
  }, [accessToken, page])

  return (
    <Row>
      <Col xs="12">
        <div className="university-list-header d-flex align-items-center justify-content-between">
          <CustomBreadCrumb data={breadcrumbItems} pageTitle="My Tasks" />
        </div>

        <div className="task-data-table table-responsive mt-4 mb-3">
          {loading ? (
            <DataTableLoader cols={10} />
          ) : (
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Task Name</th>
                  <th>Task Category</th>
                  <th>Start Date</th>
                  <th>Due Date</th>
                  <th>Target</th>
                  <th>Priority</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {taskDetails?.map((task, index) => {
                  const taskName = task?.taskName || "N/A"
                  const taskCatgeory = task?.taskCategory
                  const startDate = task?.startDate || "Not Set"
                  const dueDate = task?.dueDate || "Not Set"
                  const target = task?.target || "No Target"
                  const priority = task?.priority || "No Priority"
                  const priorityDisplay =
                    priority === "high"
                      ? "High"
                      : priority === "medium"
                        ? "Medium"
                        : "Low"

                  return (
                    <tr key={task._id} className="task-table-row">
                      <th scope="row">{(page - 1) * limit + index + 1}</th>
                      <td>{taskName}</td>
                      <td>{taskCatgeory}</td>
                      <td>{startDate}</td>
                      <td>{dueDate}</td>
                      <td>{target}</td>
                      <td>
                        <span className={`status ${priority}`}>
                          {priorityDisplay}
                        </span>
                      </td>
                      <td>
                        <span
                          className="view-task"
                            onClick={() => {
                              navigate(`/viewTask/${task._id}`, {
                                state: task,
                              })
                            }}
                        >
                          <i className="ion ion ion-md-eye" />
                        </span>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          )}
        </div>

        <div className="pagination-container d-flex align-items-center justify-content-end">
          <Pagination>
            <PaginationItem disabled={page <= 1}>
              <PaginationLink previous onClick={() => setPage(page - 1)} />
            </PaginationItem>
            {[...Array(totalPages)].map((_, index) => (
              <PaginationItem key={index} active={index + 1 === page}>
                <PaginationLink onClick={() => setPage(index + 1)}>
                  {index + 1}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem disabled={page >= totalPages}>
              <PaginationLink next onClick={() => setPage(page + 1)} />
            </PaginationItem>
          </Pagination>
        </div>
      </Col>
    </Row>
  )
}

export default TaskDataTable
